import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bc00fea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "InvoiceContentServices"
}
const _hoisted_2 = { class: "InvoiceContentServices__title" }
const _hoisted_3 = { class: "InvoiceContentServices__content" }
const _hoisted_4 = { class: "InvoiceContentServices__row__title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "InvoiceContentServices__check" }, "✓", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${_ctx.key}-${i}`,
              class: "InvoiceContentServices__row"
            }, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(service.type_name), 1),
              _hoisted_5
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}